import React from 'react';
import timeDelta from '../../../../../../common/utility/timeDelta';

import { IGridCell } from '../../../../../ui/types/IGridCell';

const ActivityCell: React.FC<IGridCell> = ({dataItem, field}) => {
  return (
    <td>
      <div className="when-cell">{timeDelta(new Date(dataItem[field]))}</div>
    </td>
  );
};

export default ActivityCell;
